import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../../feature.types";
import { buildCrudPermissions, permissionId } from "../../../shared/featureFactories";

export const PaidHistoryFeature: FeatureMetadata = {
  id: "paid-history",
  moduleName: "feesFinance",
  navigation: {
    label: "Paid History",
    path: "/paid-history",
    icon: DocumentTextIcon,
    order: 1,
    parentId: "finance-reports",
  },
  route: {
    path: "/paid-history",
    element: lazy(() => import("./pages/PaidHistoryReportPage")),
  },
  permissions: buildCrudPermissions("FeeFinance", "FinanceReports", {
    view: permissionId("FeeFinance", "FinanceReports", "paidHistory"),
    create: permissionId("FeeFinance", "FinanceReports", "export"),
    edit: permissionId("FeeFinance", "FinanceReports", "export"),
    delete: permissionId("FeeFinance", "FinanceReports", "export"),
  }),
  readiness: "live",
};
